<template>
    <form v-if="displayItems" class="form-group leftCheckboxForm">
        <h3>
            {{ heading }}
        </h3>
        <ul>
            <li v-for="item in displayItems" :key="item" class="abc-checkbox">
                <input
                    :id="item"
                    v-model="selectedItems"
                    type="checkbox"
                    :value="item"
                    class="form-check-input"
                />
                <label :for="item" class="form-check-label">{{ item }}</label>
            </li>
        </ul>
    </form>
</template>

<script>
export default {
    name: "LeftCheckboxFormWithHeading",
    props: {
        heading: {
            type: String,
            required: true
        },
        items: {
            type: Array,
            required: true
        },
        preselectedItems: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            displayItems: this.items.filter(element => {
                return element !== null && element !== undefined;
            }),
            selectedItems: this.preselectedItems
        };
    },
    watch: {
        selectedItems: "handleSelectionChanged"
    },
    methods: {
        handleSelectionChanged($items) {
            this.$emit("selected", $items);
        }
    }
};
</script>
>
